import React from 'react';
import { EmbeddedWebPageType } from '../../../lib/api/custom-page.types';
import { arePageFlagsPending, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';


export const EmbeddedUrlCustomPage: React.FunctionComponent<EmbeddedWebPageType> = (props: EmbeddedWebPageType): JSX.Element | null => {
  const eventSettings = useEventSettings();
  if (arePageFlagsPending(eventSettings)) return null;

  if (props && props.embeddedWebpageUrl) return (
    <iframe
      width='100%'
      height='100%'
      title={props.label}
      src={props.embeddedWebpageUrl}
      sandbox='allow-scripts allow-same-origin  allow-forms allow-popups allow-downloads allow-popups-to-escape-sandbox'
    />
  );
  return null;
};
